module.exports = __webpack_public_path__ + "media/images/del_logo-ef8eff12777b0fe7fd7a4ff2db495f6a.svg";